// extracted by mini-css-extract-plugin
export var locationCard = "_g7-0";